/**
 * The initial auth state.
 */
export const initialAuthState = {
  isInitialized: false,
  user: undefined,
  error: undefined,
  use_session_flow: false,
  use_login_v2: true,
}
